import Blogs from "../app/Blogs";
import Footer from "../app/Footer";
import HireTalent from "../app/HireTalent";
import Navbar from "../navigation/Navbar";
import { Link, useParams } from "react-router-dom";
import JobDesc from "./JobDesc";
import jobImg from "../../images/proof-reading.png";
import reviewWritingImg from "../../images/review-writing.png";
import toList from "../utils/ComponentUtil";
import { Typography } from "@mui/material";
import TalentImg1 from "../../images/Rectangle_1325.png"
import TalentImg2 from "../../images/Rectangle_1326.png"
import TalentImg3 from "../../images/Rectangle_1327.png"
import TalentImg4 from "../../images/Rectangle_1328.png"
import ProfilePic from "../../images/profile-1.png"
import Location from "../../images/Icon-material-location-on.png"
import ProofReadingContent from "./ProofReadingContent";
import ReviewWritingContent from "./ReviewWritingContent";
import CopyPasteContent from "./CopyPasteContent";
import Categories from "../app/Categories";
import JobTemplate from "./JobTemplate";
import NewProofReadingContent from "./NewProofReadingContent";

function DailyJobs() {
    const { job } = useParams();
    const talents = [{
        image: TalentImg1,
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg2,
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg3,
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    },
    {
        image: TalentImg4,
        desc: 'I Can Do 50 Data Entry Projects On Various',
        allDesc: 'As a business owner or manager, what would it look like to have as the data entry',
        profilePic: ProfilePic,
        profileName: 'Kaira',
        locationPic: Location,
        location: 'Chennai',
        pay: '500',
        payUnit: 'Day'
    }
    ];
    const jobDetails = {
        "proof-reading": {
            name: "Proof Reading",
            component: ProofReadingContent,
            jobImg: jobImg,
            title: "Proof Reading Job Details",
            compensation: [
                "Earn upto Rs.10/- daily by doing simple proof reading works.",
                "Check & Edit the Grammar mistakes and Misspelled words",
                "Daily 5 - 10 contents will be listed for proof reading, you can do as much as you can.",
                "Rs.1/- for each proof reading work."
            ],
            editContent: {
                title: "Proof Reading The Below Content",
                triggerText: "Edit This Content",
                submitText: "Submit",
                successMsg: 'Completed Successfully',
                validations: [
                    '* It seems you missed something to correct.',
                    '* Other users have corrected more on this content.',
                    '* Kindly Proof read the content once again.'
                ],
                subtitle: "Check and edit the grammar mistakes and mispelled words."
            },
            contentToEditToday: 8,
            contents: [
                {
                    name: "Content 1",
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman.",
                    status: "completed"
                },
                {
                    name: "Content 2",
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman.",
                    status: "in-progress"

                },
                {
                    name: "Content 3",
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman."
                }
            ],
            talentsTitle: 'Proof Reading Talents',
            talents: talents
        },
        "new-proof-reading": {
            name: "New Proof Reading",
            component: NewProofReadingContent,
            jobImg: jobImg,
            title: "New Proof Reading Job Details",
            compensation: [
                "Earn upto Rs.10/- daily by doing simple proof reading works.",
                "Check & Edit the Grammar mistakes and Misspelled words",
                "Daily 5 - 10 contents will be listed for proof reading, you can do as much as you can.",
                "Rs.1/- for each proof reading work."
            ],
            editContent: {
                title: "Proof Reading The Below Content",
                triggerText: "Start Reading",
                submitText: "Submit",
                successMsg: 'Completed Successfully',
                validations: [
                    '* You have started reading just now.  So please read the content fully and then start giving feedback. ',
                ],
                subtitle: "Check and edit the grammar mistakes and mispelled words."
            },
            contentToEditToday: 8,
            contents: [
                {
                    name: "Content 1",
                    title: '5 ways to earn in online without investing money',
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman. Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman. <br/> <br/> Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman.",
                    feedback: '',
                    other:'',
                    metrics: {
                        time: '4:30 Min',
                        words: '2500'
                    },
                    feedbackOptions: [
                        'Grammar Mistakes','Speeling Mistakes','Punctuation Mistakes','Very Poor Quality','Perfect No Corrections' 
                    ],
                    status: "completed"
                },
                {
                    name: "Content 2",
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman.",
                    title: '5 ways to earn in online without investing money',
                    feedback: '',
                    other:'',
                    metrics: {
                        time: '4:30 Min',
                        words: '2500'
                    },
                    feedbackOptions: [
                        'Grammar Mistakes','Speeling Mistakes','Punctuation Mistakes','Very Poor Quality','Perfect No Corrections' 
                    ]
                },
                {
                    name: "Content 3",
                    content: "Julian travls there in search of peace. After arreving, he encounters Yogi Raman. Yogi Raman offers Julian seven virtus for him to obtain enlightenment. After a few months, Julian returns and narates all the teachngs of Yogi Raman.",
                    title: '5 ways to earn in online without investing money',
                    feedback: '',
                    other:'',
                    metrics: {
                        time: '4:30 Min',
                        words: '2500'
                    },
                    feedbackOptions: [
                        'Grammar Mistakes','Speeling Mistakes','Punctuation Mistakes','Very Poor Quality','Perfect No Corrections' 
                    ]
                }
            ],
            talentsTitle: 'Proof Reading Talents',
            talents: talents
        },
        "review-writing": {
            component: ReviewWritingContent,
            name: "Review Writing",
            jobImg: reviewWritingImg,
            title: "Review Writing Job Details",
            compensation: [
                "Earn upto Rs.10/- daily by doing simple review writing jobs.",
                "Just write a 3-5 words of very simple review.",
                "Daily 5-10 topics will be listed for review writing.",
                "Rs.1/- per each review will be credited instantly"
            ],
            editContent: {
                title: "Proof Reading The Below Content",
                triggerText: "Edit This Content",
                submitText: "Submit",
                successMsg: 'Completed Successfully',
                validations: [
                    '* It seems you missed something to correct.',
                    '* Other users have corrected more on this content.',
                    '* Kindly Proof read the content once again.'
                ],
                subtitle: "Check and edit the grammar mistakes and mispelled words."
            },
            contentToEditToday: 8,
            contents: [
                {
                    name: "Topic 1",
                    content: "Paulo Coelho’s encanting novle in the eclectic “magical realism” category is dazzling in many ways. The style reads simply yet contains powerful emotions, interesting and deep charecters, plots twists and inspiring wisdom. An Andalusian shephard boy named Santiago travels from his homeland in Spain to the Egyptian dessert in search of a treasure buried in the Pyramids."
                },
                {
                    name: "Topic 2",
                    content: "Paulo Coelho’s encanting novle in the eclectic “magical realism” category is dazzling in many ways. The style reads simply yet contains powerful emotions, interesting and deep charecters, plots twists and inspiring wisdom. An Andalusian shephard boy named Santiago travels from his homeland in Spain to the Egyptian dessert in search of a treasure buried in the Pyramids."
                },
                {
                    name: "Topic 3",
                    content: "Paulo Coelho’s encanting novle in the eclectic “magical realism” category is dazzling in many ways. The style reads simply yet contains powerful emotions, interesting and deep charecters, plots twists and inspiring wisdom. An Andalusian shephard boy named Santiago travels from his homeland in Spain to the Egyptian dessert in search of a treasure buried in the Pyramids."
                }
            ],
            talentsTitle: 'Review Writing Talents',
            talents: talents
        },
        "copy-paste": {
            component: CopyPasteContent,
            name: "Copy Paste",
            jobImg: reviewWritingImg,
            title: "Copy Paste Job Details",
            compensation: [
                "Earn upto Rs.10/- daily by doing simple review writing jobs.",
                "Just write a 3-5 words of very simple review.",
                "Daily 5-10 topics will be listed for review writing.",
                "Rs.1/- per each review will be credited instantly"
            ],
            editContent: {
                title: "Proof Reading The Below Content",
                triggerText: "Edit This Content",
                submitText: "Submit",
                successMsg: 'Completed Successfully',
                validations: [
                    '* It seems you missed something to correct.',
                    '* Other users have corrected more on this content.',
                    '* Kindly Proof read the content once again.'
                ],
                subtitle: "Check and edit the grammar mistakes and mispelled words."
            },
            contentToEditToday: 8,
            contents: {
                requirements: [{
                    title: "Price",
                    detail: "Rs.10/- per each copy paste work."
                },
                {
                    title: "Skills Needed",
                    detail: "Little Computer Knowledge is Enough."
                },
                {
                    title: "Work Limit",
                    detail: "You can do as much as you can."
                }],
                howTo: {
                    title: "You can Start your Simple Copy Paste Work, by following these 5 Simple Steps:",
                    contents: [
                        "Just Copy the Advertisement Content Given Below.",
                        "Search “Free Classifieds” on google.com",
                        "Open any of the Free Classified website. Find & Click the “Post Free AD” Button.",
                        "Paste the Copied Content into that Classified website and post the ads successfully.",
                        "Copy that webpage address, where your Ad appears Successfully."
                    ]
                },
                notes: [
                    "You can use your own details for registering with classified sites.",
                    "Kindly avoid personal email id for classified registrations to skip promotional Emails."
                ]
            },
            talentsTitle: 'Review Writing Talents',
            talents: talents
        }
    }

    const breadcrumbs = [toList([{ to: "/", child: "Home" }, { to: "/internships", child: "Internships" }], Link)
        , <Typography className="job-page-name">{jobDetails[job].name}</Typography>]
    return (
        <div>
            <Navbar selected='Work From Home'></Navbar>
            <JobDesc {...jobDetails[job]} breadcrumbs={breadcrumbs} render={(component, editContent, contents, compensation, title, contentToEditToday) => {
                return component === CopyPasteContent ? <CopyPasteContent editContent={editContent} contents={contents} />
                    : <JobTemplate title={title} component={component} compensation={compensation}
                        editContent={editContent} contentToEditToday={contentToEditToday} contents={contents} />
            }}></JobDesc>
            <HireTalent></HireTalent>
            <Blogs style={{ background: '#FFF' }}></Blogs>
            <Categories />
            <Footer></Footer>
        </div>
    );
}

export default DailyJobs;